import React, { useEffect } from "react";
import { Fragment, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { getNumberOfCorrectAnswersByHId } from "../../../../../../features/answers/answerSlice";
import { Box, Typography } from "@mui/joy";

function NrOfCorrectAnswers() {
  const [nrOfCorrectAnswers, setNrOfCorrectAnswers] = useState(0);
  const [nrOfAnswers, setNrOfAnswers] = useState(0);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const huntId = useSelector((state) => state.auth.currentHuntState.huntId);
  async function waitForNumberOfCorrectAnswers() {
    const res = await dispatch(getNumberOfCorrectAnswersByHId(huntId)).unwrap();
    setNrOfCorrectAnswers(res.numberOfCorrectAnswers);
    setNrOfAnswers(res.numberOfAnswers);
  }
  useEffect(() => {
    waitForNumberOfCorrectAnswers();
  }, []);
  return (
    <Box textAlign="center">
      <Typography level="title-md" color="primary">
        {`${t("preliminaryResults")}: `}
        <Typography level="title-lg" color="success">
          {nrOfCorrectAnswers}
        </Typography>
        {` ${t("correctAnswers")} ${t("outOf")} `}
        <Typography level="title-lg" color="warning">
          {nrOfAnswers}
        </Typography>
        {` ${t("answers").toLowerCase()}`}
      </Typography>
    </Box>
  );
}
export default NrOfCorrectAnswers;
